import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as RecentActivity } from "../../../../assets/icons/RecentActivity.svg";
import { ReactComponent as PaymentIcon } from "../../../../assets/icons/notification_payment_icon.svg";
import { ReactComponent as SupportIcon } from "../../../../assets/icons/notification_support_ticket_icon.svg";
import { ReactComponent as RequestIcon } from "../../../../assets/icons/notification_request_icon.svg";
import { ReactComponent as OrderRequestIcon } from "../../../../assets/icons/notification_order_request_icon.svg";
import { ReactComponent as OtherIcon } from "../../../../assets/icons/Image.svg";
import { ReactComponent as RedDotAlert } from "../../../../assets/icons/red_dot_alert.svg";

import { useUpdateNotificationMutation } from "../../../../store/auth/usersApiSlice";
import { useGetUserQuery } from "../../../../store/auth/usersApiSlice";
import { replaceClaimWithAccess } from "../../../../utils/Helper";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const today = new Date();
  if (date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()) {
    return 'Today';
  } else {
    return date.toLocaleString('en-US', {
      year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true
    });
  }
};

export const Insights = ({ notification_category }) => {
  const { userInfo, token } = useSelector(state => state.auth);
  const [filteredData, setFilteredData] = useState([]);

  const { refetch } = useGetUserQuery(token);

  const [updateNotification, { isLoading }] = useUpdateNotificationMutation();

  const handleNotificationClick = async (notificationId) => {
    const updatedNotifications = filteredData.map(notification =>
      notification.id === notificationId ? { ...notification, is_read: true } : notification
    );
    setFilteredData(updatedNotifications);

    try {
      const response = await updateNotification({ notificationId, token }).unwrap();
      if (response) {
        refetch()
      }
    } catch (err) {
      console.error('Failed to update notification:', err);
      setFilteredData(filteredData);
    }
  };

  useEffect(() => {
    // Safe navigation operator to handle null or undefined userInfo
    const notifications = userInfo?.notifications || [];
    const filtered = notification_category ?
      notifications.filter(notification => notification.type === notification_category) :
      notifications;
    setFilteredData(filtered);
  }, [userInfo?.notifications, notification_category]);

  const getIcon = (type) => {
    switch (type) {
      case 'payment': return <PaymentIcon className="flex-shrink-0 h-8 w-8" />;
      case 'support_ticket': return <SupportIcon className="flex-shrink-0 h-8 w-8" />;
      case 'request': return <RequestIcon className="flex-shrink-0 h-8 w-8" />;
      case 'order_request': return <OrderRequestIcon className="flex-shrink-0 h-8 w-8" />;
      case 'follow': return <OtherIcon className="flex-shrink-0 h-8 w-8" />;
      default: return <OtherIcon className="flex-shrink-0 h-8 w-8" />;
    }
  };

  return (
    <div className="max-w-sm w-full bg-white border border-gray-300 rounded-lg py-3 pt-0 mb-5 overflow-y-auto max-h-96">
      <div className="font-semibold text-lg text-left px-4 py-2 text-gray-800 sticky top-0 bg-white">
        Recent Activities
      </div>
      {!filteredData.length ? (
        <div className="flex flex-col items-center justify-center h-full p-7">
          <RecentActivity />
          <span className="text-secondarytwo text-left text-f14 px-4 my-5 text-center">
            No activities to show.
          </span>
        </div>
      ) : (
        <div className="space-y-2 p-3">
          {filteredData.map(notification => (
            <div key={notification.id} className="flex items-center justify-between p-2 hover:bg-gray-50 cursor-pointer" onClick={() => handleNotificationClick(notification.id)}>
              <div className="flex items-center gap-3">
                {getIcon(notification.type)}
                <div className="flex flex-col">
                  <span className="text-secondarytwo text-left text-f14">
                    {replaceClaimWithAccess(notification.message)}
                  </span>
                  <span className="timing text-secondary text-left text-f12">
                    {formatDate(notification.created_at)}
                  </span>
                </div>
                {!notification.is_read && (<div className="flex flex-col items-end">
                  <RedDotAlert />
                </div>)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
